import { render, staticRenderFns } from "./ListaEtapa.vue?vue&type=template&id=16e90bb7&scoped=true&"
import script from "./ListaEtapa.vue?vue&type=script&lang=js&"
export * from "./ListaEtapa.vue?vue&type=script&lang=js&"
import style0 from "./ListaEtapa.vue?vue&type=style&index=0&id=16e90bb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e90bb7",
  null
  
)

export default component.exports